import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCustomBehance = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		fill='currentColor'
		viewBox='0 0 24 24'
		width='1em'
		height='1em'
		className='svg-icon'
		{...props}>
		<path d='M22 7.07c-.22-2.84-2.09-4.7-4.94-4.92C15.46 2 14.54 2 12 2s-3.47 0-5.06.15C4.1 2.37 2.22 4.23 2 7.07c-.15 1.6-.15 2.52-.15 4.93s0 3.33.15 4.93c.22 2.84 2.1 4.7 4.94 4.92C8.54 22 9.46 22 12 22s3.46 0 5.06-.15c2.85-.22 4.72-2.08 4.94-4.92.15-1.6.15-2.52.15-4.93s0-3.33-.15-4.93M12 17.56l-3.95-6.49.83-.49L12 15.14l3.12-4.56.83.49z' />
	</svg>
);
export default SvgCustomBehance;
